import { useMutation, useQueryClient } from "@tanstack/vue-query";
import { handleClientMethod } from "@saflib/sdk";
import { getClient } from "../../client.ts";
import type { PowerUpServiceResponseBody } from "@vendata/power-up-spec";

interface UploadOrganizationLogoData {
  file: File;
}

export const useUploadOrganizationLogo = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({
      file,
    }: UploadOrganizationLogoData): Promise<
      PowerUpServiceResponseBody["uploadLogoOrganization"][200]
    > => {
      const formData = new FormData();
      formData.append("file", file);

      return handleClientMethod(
        getClient().POST("/organization/logo", {
          body: formData as any,
        }),
      );
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["organization"] });
    },
  });
};
